import { CHANGELOGS } from '../constants/changelog.constant';

/**
 * Expose dans la console navigateur des commandes d'inspection version/changelog,
 * disponibles dans TOUS les environnements (prod comprise — ces données sont
 * déjà publiques via la modale changelog du footer) :
 *
 *   __APP__.version()    → version courante + date
 *   __APP__.changelog()  → changelog complet, groupé par version
 *
 * Aucun log au démarrage : les commandes n'écrivent que lorsqu'on les appelle.
 */
export function exposeAppInfoConsole(): void {
  if (typeof window === 'undefined') return;
  try {
    const current = CHANGELOGS[0];
    (window as unknown as Record<string, unknown>)['__APP__'] = {
      version: () => {
        // eslint-disable-next-line no-console
        console.log(
          `%c GNDAD %c ${current?.version ?? '?'} %c ${current?.date ?? ''}`,
          'background:#006A4F;color:#fff;padding:2px 6px;border-radius:3px 0 0 3px;font-weight:bold',
          'background:#43A842;color:#fff;padding:2px 6px;font-weight:bold',
          'color:#6b7280;padding:2px 4px'
        );
        return current?.version ?? '';
      },
      changelog: () => {
        for (const entry of CHANGELOGS) {
          // eslint-disable-next-line no-console
          console.groupCollapsed(
            `%c${entry.version}%c — ${entry.date} (${entry.changes.length} changement(s))`,
            'color:#43A842;font-weight:bold',
            'color:#6b7280'
          );
          for (const change of entry.changes) {
            // eslint-disable-next-line no-console
            console.log(`• ${change}`);
          }
          // eslint-disable-next-line no-console
          console.groupEnd();
        }
        return CHANGELOGS;
      },
    };
  } catch {
    /* ignore — jamais bloquant */
  }
}
